import React from "react";
import { Container } from "./styles";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";

const Cke = (props) => {
  return (
    <Container>
      <CKEditor
        editor={ClassicEditor}
        data={props.default || ""}
        onChange={(event, editor) => {
          if (!props.onChange) {
            return;
          }

          props.onChange(editor.getData());
        }}
        onBlur={(event, editor) => {
          if (!props.onBlur) {
            return;
          }

          props.onBlur(editor.getData());
        }}
      />
    </Container>
  );
};

export default Cke;
